module.exports = __webpack_public_path__ + "static/media/business.2b851100.svg";